<template>
  <div class="main-layout predicted-item-page">
    <el-card shadow="never" class="box-inner box-bg">
      <c-title slot="header" title="修改密码"></c-title>
      <div class="div-scroll modify-form">
        <c-form
          v-model="handleData"
          :formItems="formItems"
          :formRules="formRules"
          label-width="150px"
          ref="cForm"
          @submit="resetPwd"
          @resetFields="resetFields"
        ></c-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { hex_sha1 } from "@/libs/sha1.js";
import Configs from "./data/modifyPwd";
import { mapState } from "vuex";
export default {
  data() {
    let { formItems, formRules } = Configs(this);
    return {
      formItems,
      formRules,
      handleData: {
        oldPassword: "",
        newPassword: "",
        verifyPassword: "",
      },
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE"]),
  },
  created() {},
  mounted() {},
  methods: {
    //   修改密码
    resetPwd() {
      let data = {
        oldPassword: hex_sha1(this.handleData.oldPassword),
        newPassword: hex_sha1(this.handleData.newPassword),
      };
      this.$http
        .post("/account/sys/user/changePwd", data)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.$message.success(res.msg);
            this.$router.go(-1);
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    resetFields() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="less">
.modify-form {
  width: 40%;
  margin-left: 20%;
  padding-top: 5%;
}
</style>
